<template>
  <div>
    <page-title title="Export Report" :helpLink="{ path: '/pages/station-collector-help', hash: 'Report_AdHoc' }" />
    <b-row v-if="downloadState == 0">
      <b-col>
        <b-card class="mt-3">
          <h4 slot="header">Export Options</h4>
          <text-control label="Start Date" type="date" v-model="startDate" required></text-control>
          <text-control label="End Date" type="date" v-model="endDate" required></text-control>
          <select-control label="Station" v-model="stationIds" :options="stations" description="Ctrl+click to select multiple stations" multiple></select-control>
          <select-control label="Allergens" v-model="allergenIds" :options="allergens" description="Ctrl+click to select multiple allergens" multiple></select-control>
          <select-control label="Stations by User" v-model="stationIds" :options="users" description="Ctrl+click to select multiple stations" multiple></select-control>
        </b-card>
      </b-col>
      <b-col>
        <b-card class="mt-3" v-if="stationIds.length > 0 || allergenIds.length > 0">
          <h4 slot="header">Download CSV File</h4>
          <p>The report will be downloadable as a CSV file.</p>
          <b-button @click="downloadCsvFile">Download</b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="downloadState == 1">
      <b-col>
        <b-card class="mt-3">
          <h4 slot="header">Creating CSV File</h4>
          <div class="text-center">
            <b-spinner label="Spinning"></b-spinner>
          </div>
          <p>Please wait while your report is created...</p>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="downloadState == 2">
      <b-col>
        <b-card class="mt-3">
          <h4 slot="header">Download CSV File</h4>
          <p>Your report has been created.</p>
          <b-button @click="downloadState = 0">Export Another Report</b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="downloadState == 3">
      <b-col>
        <b-card class="mt-3">
          <h4 slot="header">Error Creating CSV File</h4>
          <p>An unexpected error occurred while exporting the report. This could be caused by attempting to create too large of a report. Verify the date range, stations, and allergens to include.</p>
          <b-button @click="downloadState = 0">Try Again</b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'

export default {
  name: "ReportAdHoc",
  mixins: [CrudOperationsMixin],
  props: [
  ],
  data() {
    return {
      startDate: null,
      endDate: null,
      stationIds: [],
      stations: [],
      allergenIds: [],
      allergens: [],
      users: [],
      downloadState: 0
    }
  },
  computed: {
  },
  methods: {
    load: function () {
      this.readQuery('/graphql/management', {
        query: `
          query {
            stations (limit: 1000, order: "displayCity") {
              id,
              name,
              displayCity,
              state
            }
          }`,
        variables: { }
      }, (data) => {
        this.stations = data.stations.filter(s => s.displayCity).map(s =>  {
          return {
            value: s.id,
            text: s.displayCity + (s.state ? ', ' + s.state : '') + ': ' + s.name
          };
        });
      });

      this.readQuery('/graphql/management', {
        query: `
          query {
            allergens (limit: 1000, order: "name") {
              id,
              name
            }
          }`,
        variables: { }
      }, (data) => {
        this.allergens = data.allergens.filter(s => s.name).map(s =>  {
          return {
            value: s.id,
            text: s.name
          };
        });

      });

      this.readQuery('/graphql/management', {
        query: `
          query {
            roles (limit: 1000, order: "applicationUser.userName") {
              id,
              type,
              applicationUser {
                userName,
                email,
                firstName,
                lastName
              },
              station {
                id,
                name,
                displayCity,
                state
              }
            }
          }`,
        variables: { }
      }, (data) => {
        this.users = data.roles.map(r =>  {
          return {
            value: r.station.id,
            text: r.applicationUser.userName + ' (' + r.applicationUser.firstName + ' ' + r.applicationUser.lastName + '): ' + r.station.displayCity + (r.station.state ? ', ' + r.station.state : '') + ' (' + r.station.name + ')'
          };
        });

      });
    },
    openCsvFile: function (source, filename) {
      let w = window.open();
      
      let el = w.document.createElement('a');
      el.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(source));
      el.setAttribute('download', filename);

      el.style.display = 'none';

      w.document.body.appendChild(el);
      el.click();
        w.document.body.removeChild(el);
        w.window.close();
    },
    downloadCsvFile: function () {
      this.downloadState = 1;

      this.query('/graphql/management', {
        query: `
          query ($startDate: Date, $endDate: Date, $stationIds: [ID!], $allergenIds: [ID!]) {
            exportCsvData(startDate: $startDate, endDate: $endDate, stationIds: $stationIds, allergenIds: $allergenIds)
          }`,
        variables: {
          'startDate': this.startDate,
          'endDate': this.endDate,
          'stationIds': this.stationIds,
          'allergenIds': this.allergenIds
        }}, (data) => {
          this.openCsvFile(data.exportCsvData, 'NABTemplate.csv');

          this.downloadState = 2;
        }, () => { this.downloadState = 3; }, null, null, null);
    }
  },
  watch: {
  },
  mounted () {
    let d = new Date();
    d.setMonth(d.getMonth() - 1);
    this.startDate = d.toJSON().slice(0,10);
    this.endDate = new Date().toJSON().slice(0,10);
    this.load();
  }
};
</script>